import React from 'react'

const MyDetailsIcon = ({ width = '1em', height = '1em', fill = '#333', ...props }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill={fill} width={width} height={height} {...props}>
    <path d='M7.5 4.5V21H18v-6.75a.75.75 0 1 1 1.5 0v7.5a.75.75 0 0 1-.75.75H2.25a.75.75 0 0 1-.75-.75v-18A.75.75 0 0 1 2.25 3h10.5a.75.75 0 1 1 0 1.5H7.5zM6 4.5H3V21h3V4.5zm6 8.25a.75.75 0 0 1-.75-.75V8.25a.75.75 0 0 1 .22-.53l6-6a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1 0 1.06l-5.78 5.78a1.5 1.5 0 0 1-1.06.44H12zm.75-1.5h2.69L20.69 6 18 3.31l-5.25 5.25v2.69z' />
  </svg>
)

export default MyDetailsIcon
